import React from "react";

// STYLES
import styled from "styled-components";
import Colors from "../../../shared/colors";
import "./applyRadio.css";

import { RadioGroup, RadioButton } from "react-radio-buttons";

export default class Radio extends React.Component {
  render() {
    const { title, required, value, t } = this.props;

    const onChangeRadio = (value) => {
      this.props.onChange(value);
    };

    return (
      <ApplyContent>
        <Title>
          {title}
          {required && "*"}
        </Title>
        <RadioGroup
          onChange={onChangeRadio}
          value={value}
          horizontal
          className="RadioGroup"
        >
          <RadioButton
            value="sim"
            rootColor={"#E6EBEC"}
            pointColor={Colors.primary}
            iconSize={7.5}
            iconInnerSize={7.5}
          >
            <span className={value !== "sim" ? "noSelected" : ""}>
              {t("Yes")}
            </span>
          </RadioButton>
          <RadioButton
            value="nao"
            rootColor={"#E6EBEC"}
            pointColor={Colors.primary}
            iconSize={7.5}
            iconInnerSize={7.5}
          >
            <span className={value !== "nao" ? "noSelected" : ""}>
              {t("No")}
            </span>
          </RadioButton>
        </RadioGroup>
      </ApplyContent>
    );
  }
}

const ApplyContent = styled.div`
  margin-bottom: 25px;
`;
const Title = styled.div`
  color: hsl(0, 0%, 17%);
  font-family: "PT Sans";
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  margin-bottom: 8px;
`;



// WEBPACK FOOTER //
// ./src/components/apply/radio/radio.js